import {
  CheckCircleOutlined,
  WarningOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { notification } from "antd";
import { COLORS } from "../../../config/theme";

const openNotification = ({ message, description, icon }) => {
  const { success, danger, warning } = COLORS;
  notification.open({
    message,
    description,
    icon:
      icon === "success" ? (
        <CheckCircleOutlined style={{ color: success }} />
      ) : icon === "error" ? (
        <WarningOutlined style={{ color: danger }} />
      ) : (
        <InfoCircleOutlined style={{ color: warning }} />
      ),
    duration: 1.5,
    style: { borderRadius: 8 },
  });
};

export { openNotification };
